import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductoService } from 'src/app/services/producto/producto.service';

@Component({
  selector: 'app-editar-producto',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './editar-producto.component.html',
  styleUrl: './editar-producto.component.css',
  standalone: true
})
export class EditarProductoComponent implements OnInit {
  id!: number;
  loading = false;
  error = '';

  form = this.fb.group({
    nombre: ['', Validators.required],
    precio: [0, [Validators.required, Validators.min(1)]],
    stock: [0, [Validators.required, Validators.min(0)]],
    codigoBarras: ['', Validators.required]
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private productoService: ProductoService
  ) {}

  ngOnInit(): void {
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    this.cargarProducto();
  }

  cargarProducto() {
    this.productoService.getProducto(this.id).subscribe({
      next: p => this.form.patchValue(p),
      error: () => this.error = 'Error al cargar producto'
    });
  }

  guardar() {
    if (this.form.invalid) return;
    this.loading = true;

    this.productoService.actualizarProducto(this.id, {
      nombre: this.form.value.nombre ?? '',
      precio: this.form.value.precio ?? 0,
      stock: this.form.value.stock ?? 0,
      codigoBarras: this.form.value.codigoBarras ?? '',
      usuarioId: Number(localStorage.getItem('userId')),
      productoId: this.id,
      eliminado: false,
      fechaAlta: new Date(),
      fechaModificacion: new Date()
    }).subscribe({
      next: () => (alert("Producto editado con éxito"),this.router.navigate(['/productos'])),
      error: () => {
        this.error = 'Error al guardar';
        this.loading = false;
      }
    });
  }

  cancelar() {
    this.router.navigate(['/productos']);
  }
  volverAtras() {
    this.router.navigate(['/productos']);
  }
}
